import React from 'react'
import PropTypes from 'prop-types'

// Models
import Payment from 'models/Payment'

// Components
import Space from 'ui/Space'
import Text from 'ui/Text'

// Style

export default function ColumnAmountMobile({ row }) {
  return (
    <Space direction="vertical" size={5}>
      <div className="right-wrapper">
        <div className="onMoblie">
          <Text style={{ color: 'black', fontWeight: 'normal' }}>
            {row.method}
          </Text>
          <Text
            style={{ fontSize: '16px', fontWeight: 'bold', padding: '0 0 7px' }}
          >
            {row.netAmount}
          </Text>
        </div>
        <div className="onMoblie">
          <Text style={{ color: 'black', fontWeight: 'normal' }}>
            <span style={{ width: 125, display: 'inline-block' }}>
              Payment status:
            </span>

            <span
              style={{
                fontWeight: 'normal',
                color: `${row.statusColor}`,
              }}
            >
              • {row.status}
            </span>
          </Text>
        </div>
        <div className="onMoblie">
          <Text style={{ color: 'black', fontWeight: 'normal' }} size={12}>
            <span style={{ width: 125, display: 'inline-block' }}>
              Payment received:
            </span>
            {row.paymentReceived && (
              <>
                <span
                  style={{
                    color: '#2f9baa',
                  }}
                >
                  • Yes
                </span>
                <span> {row.paymentReceivedAt}</span>
              </>
            )}
            {!row.paymentReceived && (
              <span
                style={{
                  color: '#FA6383',
                }}
              >
                • Not yet
              </span>
            )}
          </Text>
        </div>
        <div className="onMoblie">
          <Text style={{ color: 'black', fontWeight: 'normal' }}>
            <span style={{ width: 125, display: 'inline-block' }}>
              O.R. upload:
            </span>
            {row.withOR && (
              <>
                <span
                  style={{
                    color: '#2f9baa',
                  }}
                >
                  • Yes
                </span>
                <span> {row.orUploadedAt}</span>
              </>
            )}
            {!row.withOR && (
              <span
                style={{
                  color: '#FA6383',
                }}
              >
                • Not yet
              </span>
            )}
          </Text>
        </div>
      </div>
    </Space>
  )
}

ColumnAmountMobile.propTypes = {
  row: PropTypes.instanceOf(Payment),
}

ColumnAmountMobile.defaultProps = {
  row: new Payment(),
}
